import React from "react";
import { useSelector } from "react-redux";
import VizButton from "../VizButtons/VizButton";

function SubmitButton({ handleOnSubmit, disabledBtn }) {
  const state = useSelector((state) => state.atomizer);

  const [showButton, setShowButton] = React.useState(true);

  const EnableButton = () => {
    if (state?.sourceType === "PDF" || state?.sourceType === "PDF Native") {
      if (state?.jobId?.length > 0 && state?.uploadFileData !== null) {
        return false;
      }
    }
    if (state?.sourceType === "Image") {
      if (state?.jobId?.length > 0 && state?.uploadFileData !== null) {
        return false;
      }
    }
    if (state?.sourceType === "Video") {
      if (state?.jobId?.length > 0 && state?.uploadFileData !== null) {
        return false;
      }
    }
    if (
      state?.sourceType === "Scrape URL" &&
      state?.Name?.length > 0 &&
      state?.Link?.length > 0 &&
      typeof state?.UrlDepth === "number" &&
      typeof state?.Frequency === "number" &&
      state?.Link?.toString().startsWith("https://") || state?.Link?.toString().startsWith("http:")
    ) {
      return false;
    }
    

    // if (state?.sourceType === "Scrape URL") {
    //   if (state?.Name?.length > 0 && state?.Link?.length > 0) {
    //     if (state?.UrlDepth?.length > 0 && state?.Frequency?.length > 0) {
    //       if (
    //         state?.UrlDepth !== "Select Depth" &&
    //         state?.Frequency !== "Select Frequency"
    //       ) {
    //         if (
    //           state?.Link?.toString().startsWith("https://" || "http:") ||
    //           state.Link?.toString().startsWith("http:")
    //         ) {
    //           return false;
    //         }
    //       }
    //     }
    //   }
    // }
    if (state?.sourceType === "List of PDF URL Links (CSV)") {
      if (state?.jobId.length > 0 && state?.uploadFileData !== null) {
        return false;
      }
    }

    if (state?.sourceType === "Q&A List (CSV)") {
      if (
        state?.uploadFileData !== null &&
        state?.Seeker !== null &&
        state?.Expert !== null
        // (state?.seekerEmail && state?.expertEmail)
      ) {
        return false;
      }
    }

    if (state?.sourceType === "List of Bloomfire Links (CSV)") {
      if (state?.uploadFileData !== null) {
        return false;
      }
    }
    if (state?.sourceType === "PDF URL Link") {
      if (
        (state?.jobId?.length > 0 &&
          state?.UrlValue?.length > 0 &&
          state?.UrlValue?.toString().startsWith("https://")) ||
        state?.UrlValue?.toString().startsWith("http:")
      ) {
        return false;
      }
    }

    if (state?.sourceType === "List of PDF URL Links (CSV)") {
      if (state?.jobId?.length > 0 && state?.uploadFileData !== null) {
        return false;
      }
    }
    if (state?.sourceType === "Multiple Files") {
      if (state?.jobId?.length > 0 && state?.uploadFileData !== null) {
        return false;
      }
    }
    if (state?.sourceType === "Bloomfire Category") {
      if (state?.selectedCategories?.length > 0) {
        return false;
      }
    }
    return showButton;
  };

  return (
    <>
      {state?.loading ? (
        <>
          <button
            style={{
              padding: '8px 12px 8px 12px',
              borderRadius: '6px',
              fontSize: '14px',
              lineHeight: '24px',
              fontWeight: 400,
              boxShadow: '0px 1px 2px 0px #1018280D',
              color: '#FFFFFF',
              border: '1px solid  #fff',
              height: '40px',
              minWidth: '88px',
              background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
              marginBottom: '14px',
              cursor: "not-allowed" ,
              opacity:  "0.7" 
              // disabled:EnableButton() ?

            }}
            // onClick={() => handleOnSubmit()}
            disabled={true}
          >
            Submiting...
          </button> 
        </>
      ) : (
        <>
          <button
            style={{
              padding: '8px 12px 8px 12px',
              borderRadius: '6px',
              fontSize: '14px',
              lineHeight: '24px',
              fontWeight: 400,
              boxShadow: '0px 1px 2px 0px #1018280D',
              color: '#FFFFFF',
              border: '1px solid  #fff',
              height: '40px',
              minWidth: '88px',
              background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
              marginBottom: '14px',
              cursor: EnableButton() ? "not-allowed" : "pointer",
              opacity: EnableButton() ? "0.7" : ""
              // disabled:EnableButton() ?

            }}
            onClick={() => handleOnSubmit()}
            disabled={EnableButton() ? true : false}
          >
            Submit
          </button>
          {/* <VizButton
            size={3}
            type={EnableButton() ? "Disabled" : "Primary"}
            onClick={() => handleOnSubmit()}
          >
            Submit
          </VizButton> */}
        </>
      )}
    </>
  );
}

export default SubmitButton;
